"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = LinkOutLight;

var _LinkOutLight = require("@adobe/react-spectrum-workflow/dist/LinkOutLight");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function LinkOutLight(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_LinkOutLight.A4uLinkOutLight, null));
}